import { API } from '~apis/axios/instance';
import { AuthModel } from '~models/auth';
import { ResponseBaseWithData } from '~types/response';

/**
 * 이메일 인증코드를 payload의 이메일로 전송
 * @link http://revenuemarket-apollo11-dev.eba-isum2qyp.ap-northeast-2.elasticbeanstalk.com/swagger-ui/index.html#/user-sign-controller/requestPasscode
 * @param payload
 * @returns
 */
export default function postPassCode(payload: AuthModel.PasscodeRequest) {
  return API.post<ResponseBaseWithData>('/api/v3/users/passcode', {
    data: payload,
  });
}
